import React from 'react';
import './PageHero.css';

function PageHero({ title, subtitle }) {
  return (
    <section className="page-hero">
      <div className="page-hero-bg" />
      <div className="page-hero-grain" />
      <div className="page-hero-content container">
        <h1 className="page-hero-title">{title}</h1>
        {subtitle && <p className="page-hero-subtitle">{subtitle}</p>}
      </div>
    </section>
  );
}

export default PageHero;
